import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../styles/DashboardStyling/SponsorDropdown.css";

const SponsorDropdown = ({
  userData,
  selectedSponsor,
  setSelectedSponsor,
  onSponsorChange,
  sponsors,
  setSponsors,
}) => {
  // const [sponsors, setSponsors] = useState([]);

  // useEffect(() => {
  //   fetchSponsors();
  // }, []);

  // const fetchSponsors = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/sponsors`
  //     );
  //     if (response.data.success) {
  //       setSponsors(response.data.sponsors || []);
  //     } else {
  //       console.error(
  //         "Error: API returned success=false",
  //         response.data.message
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error fetching sponsors:", error);
  //   }
  // };

  const isRestrictedRole = (role) => {
    return ["Sponsor", "Board Member"].includes(role);
  };

  const getAllowedSponsors = () => {
    if (!userData || !userData.Role) {
      console.error("No userData or role found:", userData);
      return [];
    }
    const userRoles = userData.Role;
    if (!Array.isArray(userRoles)) {
      console.error("Invalid userRoles format:", userRoles);
      return [];
    }
    let allowedSponsors = sponsors;
    if (userRoles.some((role) => isRestrictedRole(role))) {
      allowedSponsors = sponsors.filter((sponsor) =>
        userData.Company.includes(sponsor.spname)
      );
    }
    return allowedSponsors;
  };

  const handleSponsorChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedSponsor(selectedValue);
    onSponsorChange(selectedValue);
  };

  return (
    <div className="sponsor-dropdown">
      <label className="dropdown-label">Sponsor:</label>
      <select
        className="dropdown"
        value={selectedSponsor}
        onChange={handleSponsorChange}
      >
        <option value="All">All</option>
        {getAllowedSponsors().map((sponsor) => (
          <option
            className="dropdown-list"
            key={sponsor.spid}
            value={sponsor.spname}
          >
            {sponsor.spname}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SponsorDropdown;
